import useI18n from 'i18n/useI18n';
import { useEffect, useMemo } from 'react';
import { 
  getTranslatedCategories,
  getTranslatedCategory,
} from 'pages/MenuItems/utils/transformers';

const useTranslatedFilterSelect = ( baseOptions = null, selectedOption = null, updateSelectedOption = ([])=>{}, baseOption = null ) => {
  const { translate, selectedLang } = useI18n();

  useEffect(()=>{
    if(!!baseOptions && baseOptions.length > 1 ){
      const option =  !!baseOption ? baseOption : baseOptions[0];
      const initOption = getTranslatedCategory(
        option,
        translate,
        selectedLang
      );
      updateSelectedOption(initOption);
    }
  },[baseOptions]);

  useEffect(()=>{
    if(!baseOptions || !selectedOption) return;

    const option = baseOptions.find( option => option.value === selectedOption.value );
    if( !!option ){
      const newOption = getTranslatedCategory(
        option,
        translate,
        selectedLang
      );
      updateSelectedOption(newOption);
    }
  }, [selectedLang]);

  const options = useMemo(()=>{
    if( !baseOptions ) return null;

    return getTranslatedCategories(baseOptions, translate, selectedLang);
  }, [selectedLang, baseOptions]);

  return ([
    options,
    selectedOption
  ]);
}
export default useTranslatedFilterSelect;